import { Button, CircularProgress } from '@mui/material';
import React from 'react';

interface Props {
  size?: 'small' | 'medium' | 'large';
  variant?: 'contained' | 'outlined' | 'text';
  text: string;
  showIcon: boolean;
  iconPosition?: 'start' | 'end' | undefined;
  icon?: any;
  width?: '100%' | 'auto';
  onClick?: (e?: any) => void;
  type?: 'button' | 'reset' | 'submit';
  disabled?: boolean;
  iconType?: 'image' | 'svg';
  dashedBorder?: boolean;
  pressed?: boolean;
  onMouseDown?: () => void;
  isMobileTextVisible?: boolean;
  id: string;
  loading?: boolean;
  className?: string;
  display?: boolean;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'lite';
}

const CustomButton: React.FC<Props> = props => {
  const {
    size,
    variant,
    text,
    showIcon,
    iconPosition,
    icon,
    width,
    onClick,
    type,
    disabled,
    iconType,
    dashedBorder,
    pressed,
    onMouseDown,
    isMobileTextVisible = true,
    id,
    loading,
    className,
    display,
    color,
  } = props;
  const windowWidth = window.innerWidth;
  return showIcon ? (
    iconPosition === 'start' ? (
      // <Box className="customBtn">
      <Button
        type={type}
        disabled={disabled}
        onClick={onClick}
        size={size}
        id={id}
        sx={{
          ...(display && { display: 'none' }),
          '&.Mui-disabled': {
            color: 'black !important', // affects MUI icons / SVG icons using currentColor
            '& img': {
              filter: 'brightness(0)', // makes light images appear black-ish
            },
            '& svg': {
              color: 'black', // force SVG icons to black
              fill: 'black',
            },
            cursor: 'not-allowed',
            filter: 'brightness(0)',
          },
        }}
        color={color}
        // disabled={true}
        className={
          variant === 'contained'
            ? `innerButtonContained ${
                !isMobileTextVisible ? 'isMobileTextVisible' : null
              }  ${className}`
            : `innerButtonOutlined ${dashedBorder ? 'dashedBorder' : ''} ${
                pressed ? 'pressed' : ''
              }
            ${!isMobileTextVisible ? 'isMobileTextVisible' : null}
            ${className}
            `
        }
        variant={variant}
        startIcon={
          iconType === 'svg' ? (
            icon
          ) : (
            <img src={icon} alt={text} role="presentation" />
          )
        }
        disableElevation
        disableFocusRipple
      >
        <span>
          {isMobileTextVisible ? text : <> {windowWidth > 768 ? text : ''}</>}
        </span>
      </Button>
    ) : (
      // </Box>
      // <Box className="customBtn">
      <Button
        id={id}
        type={type}
        onClick={onClick}
        disabled={disabled}
        size={size}
        color={color}
        className={
          variant === 'contained'
            ? `innerButtonContained ${
                !isMobileTextVisible ? 'isMobileTextVisible' : null
              }`
            : `innerButtonOutlined ${dashedBorder ? 'dashedBorder' : ''} ${
                pressed ? 'pressed' : ''
              }
            ${
              !isMobileTextVisible ? 'isMobileTextVisible' : null
            }  ${className}`
        }
        variant={variant}
        endIcon={
          iconType === 'svg' ? (
            icon
          ) : (
            <img src={icon} alt={text} role="presentation" />
          )
        }
        disableElevation
        disableFocusRipple
      >
        {/* {windowWidth > 768 ? text : ''} */}
        <span>
          {' '}
          {isMobileTextVisible ? text : <> {windowWidth > 768 ? text : ''}</>}
        </span>
      </Button>
      // </Box>
    )
  ) : (
    // <Box className="customBtn">
    <Button
      id={id}
      onMouseDown={() => {
        if (onMouseDown) {
          onMouseDown();
        }
      }}
      color={color}
      type={type}
      onClick={onClick}
      disabled={disabled}
      size={size}
      variant={variant}
      className={`customButton ${
        variant === 'contained' ? 'customBtnPrimary' : 'customBtnSecondary'
      } ${dashedBorder ? 'dashedBorder' : ''} ${
        pressed ? 'pressed' : ''
      }  ${className} ${
        !isMobileTextVisible ? 'isMobileTextVisible' : null
      }  ${className}`}
      sx={{
        width: { width },
        ...(display && { display: 'none' }),
      }}
      disableElevation
      disableFocusRipple
      startIcon={
        loading ? (
          <CircularProgress size={20} sx={{ color: '#ffffff' }} />
        ) : null
      }
    >
      {text}
    </Button>
    // </Box>
  );
};

CustomButton.defaultProps = {
  type: 'button',
};

export default CustomButton;
